<template>
  <div class="yajin-bujiao-record">
    <SelectInpatient @selectChange="selectChange" />
    <van-loading v-show="loading" class="my-loading" type="spinner" color="#1989fa" />
    <van-cell-group v-for="(item,index) in list" v-show="list.length > 0" :key="index" inset class="list-box" size="large">
      <van-cell
        center
        :title="`补缴日期：${item.operDate}`"
        value="充值成功"
        :label="`补缴金额：${item.cost}`"
        is-link
        @click="toDetail(item)"
      />
    </van-cell-group>
    <noData v-show="list.length === 0 && !loading" title="暂未获取到您的押金预缴记录" />
  </div>
</template>
<script>
import SelectInpatient from '@/components/selectInpatient'
import inpatientMinxins from './mixins'
export default {
  name: 'YaJinBuJiaoRecord',
  components: {
    SelectInpatient
  },
  mixins: [inpatientMinxins],
  data() {
    return {
      list: [],
      loading: false
    }
  },
  created() {},
  mounted() {},
  methods: {
    getData() {
      this.loading = true
      if (!this.admissionNum) {
        this.loading = false
        return
      }
      const params = {
        admissionNum: this.admissionNum,
        patientZyName: this.patientZyName
      }
      this.$Apis.getZYPaymentInAdvanceInfo(params).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.list = res.data.reportItems || []
        } else {
          this.$toast.fail(res.message)
        }
      })
    },
    toDetail(item) {
      this.$router.push({
        path: '/yajinbujiaodetail',
        query: {
          cost: item.cost,
          deptName: item.deptName,
          operDate: item.operDate,
          orderNumber: item.orderNumber,
          paymentMethod: item.paymentMethod,
          productDescription: item.productDescription
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.yajin-bujiao-record{
  padding: .1rem 0;
  .list-box{
    margin-top: .1rem;
  }
  /deep/.van-cell__title{
    color: #555;
  }
}
</style>
